import DOMPurify from 'dompurify'
import { convert } from 'html-to-text'

const HREF_ATTRIBUTE_PATTERN = /\bhref\s*=\s*(?:("|')(?:(?!\1)[\s\S])*\1|[^\s"'>]+)/gi

export const sanitizeEmailHtml = (html: string, { neutralizeLinks = false }: { neutralizeLinks?: boolean } = {}): string => {
  const cleaned = DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ['style', 'form', 'input', 'button'] })
  return neutralizeLinks ? cleaned.replace(HREF_ATTRIBUTE_PATTERN, 'href="#" tabindex="-1"') : cleaned
}

export const emailHtmlToPlainText = (html: string): string =>
  convert(html, {
    wordwrap: false,
    selectors: [{ selector: 'a', options: { hideLinkHrefIfSameAsText: true } }],
  })
